export default {
	SET_ALARMS(state, alarms) {
		state.alarms = alarms;
	},
	UPDATE_ALARM(state, alarm) {
		const idx = state.alarms.findIndex(t => t.id === alarm.id);
		if (idx != -1) {
			Object.assign(state.alarms[idx], alarm);
		}
	},
	SET_TOTAL_ALARMS(state, total) {
		state.totalAlarms = total;
	},
	// Setting
	SET_ALARMS_SETTING(state, alarmsSetting) {
		state.alarmsSetting = alarmsSetting;
	},
	ADD_ALARM_SETTING(state, alarm) {
		state.alarmsSetting.unshift(alarm);
		state.totalAlarmsSetting = +1;
	},
	UPDATE_ALARM_SETTING(state, alarm) {
		const idx = state.alarmsSetting.findIndex(t => t.id === alarm.id);
		if (idx != -1) {
			Object.assign(state.alarmsSetting[idx], alarm);
		}
	},
	DELETE_ALARM_SETTING(state, alarmId) {
		const idx = state.alarmsSetting.findIndex(t => t.id == alarmId);
		state.alarmsSetting.splice(idx, 1);
		state.totalAlarmsSetting = -1;
	},
	SET_TOTAL_ALARMS_SETTING(state, total) {
		state.totalAlarmsSetting = total;
	},
	SET_IS_RECEIVED_ALARMSG(state, id) {
		const idx = state.alarms.findIndex(t => t.id === id);
		if (idx != -1) {
			state.alarms[idx].is_received = true;
		}
	}
};
